import React, { FC } from 'react';
import { Controller, Control } from 'react-hook-form';
import type { MedicalHistoryValues } from '../types/flow';
import {
  FormInput, FormSelect, FLabel, SectionDivider,
} from '../../assessment-portal/components/form-fields';
import YesNoButtons from '../../assessment-portal/components/yes-no-buttons';
import {
  YES_NO_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  LIVING_SITUATION_OPTIONS,
} from '../data/constants';

interface PersonalBackgroundFormProps {
  control: Control<MedicalHistoryValues>;
}

const PersonalBackgroundForm: FC<PersonalBackgroundFormProps> = ({ control }) => (
  <>
    <h2 className="text-xl font-bold mb-1 text-brand-dark">Medical History — Part 1 of 4</h2>
    <p className="text-slate-500 text-sm mb-6">Help your clinical team prepare by providing some background information.</p>

    <div className="space-y-5 md:space-y-5">
      <SectionDivider>Personal Background</SectionDivider>

      <div className="adhd-mq-card">
        <FLabel isRequired>Occupation</FLabel>
        <Controller
          name="occupation"
          control={control}
          render={({
            field: {
              ref, name, value, onChange, onBlur,
            },
          }) => <FormInput ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur} placeholder="e.g. Teacher, Student, Accountant, Not currently working" />}
        />
      </div>

      <div className="adhd-mq-card">
        <FLabel isRequired>Marital / Relationship Status</FLabel>
        <Controller
          name="marital"
          control={control}
          render={({
            field: {
              ref, name, value, onChange, onBlur,
            },
          }) => (
            <FormSelect ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur}>
              {MARITAL_STATUS_OPTIONS.map((o) => <option key={o}>{o}</option>)}
            </FormSelect>
          )}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="adhd-mq-card md:bg-transparent md:border-0 md:p-0 md:mb-0">
          <FLabel isRequired>Do you have children?</FLabel>
          <Controller
            name="children"
            control={control}
            render={({
              field: {
                ref, name, value, onChange, onBlur,
              },
            }) => (
              <>
                <div className="md:hidden">
                  <YesNoButtons
                    value={value}
                    onChange={onChange}
                    options={YES_NO_OPTIONS}
                    ariaLabel="Do you have children?"
                  />
                </div>
                <div className="hidden md:block">
                  <FormSelect ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur}>
                    {YES_NO_OPTIONS.map((o) => <option key={o}>{o}</option>)}
                  </FormSelect>
                </div>
              </>
            )}
          />
        </div>
        <div className="adhd-mq-card md:bg-transparent md:border-0 md:p-0 md:mb-0">
          <FLabel isRequired>Living Situation</FLabel>
          <Controller
            name="living"
            control={control}
            render={({
              field: {
                ref, name, value, onChange, onBlur,
              },
            }) => (
              <FormSelect ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur}>
                {LIVING_SITUATION_OPTIONS.map((o) => <option key={o}>{o}</option>)}
              </FormSelect>
            )}
          />
        </div>
      </div>
    </div>
  </>
);

export default PersonalBackgroundForm;
